export const PICKUP_HOLD_KEYS = [
  { key: 'customs_status', name: 'Customs' },
  { key: 'freight_status', name: 'Freight' },
  { key: 'shipping_line_status', name: 'Line' },
  { key: 'tmf_status', name: 'TMF' },
  { key: 'terminal_status', name: 'Terminal' },
  { key: 'holds_status', name: 'Other holds' },
];

export const IMPORT_STATUS_ENUM = {
  VESSEL: 'vessel',
  YARD: 'yard',
  DEPARTED: 'departed',
  RAIL: 'rail',
  UNKNOWN: 'unknown',
};

export const CONTAINER_STATUS_ENUM = {
  TERMINATED: 'terminated',
  GATED_OUT: 'gated_out',
  ON_VESSEL: 'on_vessel',
  IMPORT: 'import',
  PENDING: 'pending',
  LOADING: 'loading',
};

export const DATE_DISPLAY_FORMAT = 'll';
